export class BreadcrumbService {
  constructor() {
    this.linkConfig = {
      'evaluation-process': {
        label: 'Nueva evaluación',
        active: true
      },
      'evaluation-summary': {
        label: 'Resumen',
        active: true
      }
    };
  }

  getLinkConfiguration(from, evaluationId) {
    const config = this.linkConfig[from];
    if (config) {
      return {
        to: { name: from, params: { evaluationId } },
        active: config.active,
        label: config.label
      };
    }
    return null;
  }

  getLinks(evaluationId, debtorFullName, from) {
    const links = [
      {
        to: { name: 'evaluation-detail', params: { evaluationId } },
        active: false,
        label: debtorFullName
      }
    ];

    const additionalLink = this.getLinkConfiguration(from, evaluationId);
    if (additionalLink) {
      links.push(additionalLink);
    }

    return links;
  }
}
